import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgLeftSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M11 1L4 8L11 15"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgLeftSmall.displayName = 'SvgLeftSmall';
const LeftSmall = withForgeIconProps(SvgLeftSmall, {
  name: 'Left',
  usage: 'Use to go back to the previous page or item.',
  related: 'return, navigation',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default LeftSmall;
